import { render, staticRenderFns } from "./DatasetDetail.vue?vue&type=template&id=2dfed090&scoped=true&"
import script from "./DatasetDetail.vue?vue&type=script&lang=js&"
export * from "./DatasetDetail.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDetail.vue?vue&type=style&index=0&id=2dfed090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfed090",
  null
  
)

export default component.exports